module.exports = __webpack_public_path__ + "media/src/img/rutube-icon-efd4f978456a46ec23f02a0dc3089e57.svg";